<button class="bx--btn bx--btn--primary"
  type="button"
  (click)="onNewProject()">
  Add new project<svg class="bx--btn__icon mr-0"
    ibmIconAdd
    size="20"></svg>
</button>